var render, staticRenderFns
import script from "./config-row.vue?vue&type=script&lang=js"
export * from "./config-row.vue?vue&type=script&lang=js"
import style0 from "./config-row.vue?vue&type=style&index=0&id=37d0cb8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports